import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

const SocialLinks = ({ variant = 'circle' }) => {
  const { isSpanish } = useLanguage();

  // Per user rule (May 2026): social buttons MUST be alphabetical
  // (Facebook → Instagram → LinkedIn → Threads → TikTok → YouTube).
  const links = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/share/18dCfoSuwp/',
      label: isSpanish ? 'Síguenos en Facebook' : 'Follow us on Facebook',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      bg: 'bg-[#1877F2] hover:bg-[#166FE5]',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/clearcommunicationapp?igsh=MXZjbWZiamQ4bjJpOA==',
      label: isSpanish ? 'Síguenos en Instagram' : 'Follow us on Instagram',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
        </svg>
      ),
      bg: 'bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] hover:opacity-90',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/clearcommunicationapp/',
      label: isSpanish ? 'Síguenos en LinkedIn' : 'Follow us on LinkedIn',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      bg: 'bg-[#0A66C2] hover:bg-[#004182]',
    },
    {
      name: 'Threads',
      url: 'https://www.threads.com/@clearcommunicationapp',
      label: isSpanish ? 'Síguenos en Threads' : 'Follow us on Threads',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.083.717 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.17.408-2.243 1.33-3.023.88-.744 2.084-1.168 3.58-1.263 1.13-.072 2.175.032 3.12.28-.078-.89-.356-1.567-.831-2.005-.59-.545-1.503-.834-2.637-.834h-.047c-.94.01-1.722.27-2.32.776l-1.373-1.49c.93-.775 2.115-1.19 3.517-1.236h.107c1.752 0 3.132.536 3.988 1.55.718.85 1.12 2.015 1.191 3.442.339.163.657.35.95.563 1.068.776 1.823 1.85 2.18 3.103.483 1.694.274 3.835-1.38 5.497-1.795 1.806-4.072 2.63-7.165 2.651zm-.108-7.593c-1.413.088-2.126.747-2.09 1.38.016.285.162.618.556.869.473.303 1.122.43 1.829.393 1.09-.06 1.91-.458 2.438-1.187.36-.497.601-1.122.721-1.862-.75-.2-1.581-.303-2.472-.303-.333 0-.666.016-.982.046v-.001l-.001.665z"/>
        </svg>
      ),
      bg: 'bg-black hover:bg-gray-800 dark:bg-white dark:hover:bg-gray-200 dark:text-black',
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@clearcommunicationapp',
      label: isSpanish ? 'Síguenos en TikTok' : 'Follow us on TikTok',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      ),
      bg: 'bg-black hover:bg-gray-800 dark:bg-white dark:hover:bg-gray-200 dark:text-black',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@ClearCommunicationApp',
      label: isSpanish ? 'Suscríbete en YouTube' : 'Subscribe on YouTube',
      icon: (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      bg: 'bg-[#FF0000] hover:bg-[#CC0000]',
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-2" data-testid="social-links">
      {links.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          title={link.label}
          className={
            variant === 'circle'
              ? `inline-flex items-center justify-center w-9 h-9 rounded-full text-white transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00E5CC] ${link.bg}`
              : `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-white text-xs font-medium transition-all ${link.bg}`
          }
          data-testid={`social-${link.name.toLowerCase()}`}
        >
          {link.icon}
          {variant !== 'circle' && link.label}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
